import Vue from "vue";
import Component from "vue-class-component";

@Component
export class FaqUrl extends Vue {
  get $m_faqUrl() {
    return this.$i18n.locale === "en"
      ? this.$constant.PDF_FAQ_URL_EN
      : this.$constant.PDF_FAQ_URL_BM;
  }
}
